import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const SecondPage = () => (
  <Layout>
    <SEO title="Contact Us" description="" />
    <h1>Contact Us</h1>
  </Layout>
)

export default SecondPage
